module.exports = __webpack_public_path__ + "img/1bd44e5.jpg";